//Inspiration from -- https://codepen.io/curthusting/pen/fkCzh
var _debounce = require('lodash.debounce');

function digitalScratcherService(options) {

    const defaultOptions = {
        isMouseDown: false,
        scratchers: []
    }
    const scratcherModel = {
        name: undefined,
        containerId: undefined,
        canvasId: undefined,
        isLoaded: true,
        cursorImageUrl: undefined,
        images: {
            front: {
                url: undefined,
                img: undefined
            },
            back: {
                url: undefined,
                img: undefined
            }
        },
        canvas: {
            temp: undefined,
            draw: undefined
        }
    };

    this.options = $.extend(true, defaultOptions, options);

    this.addScratcher = (obj) => this.options.scratchers.push(obj);
    this.getScratcherByName = (sName) => this.options.scratchers.find(x => x.name === sName);
    this.getScratcherIsLoaded = (sName) => this.options.scratchers.find(x => x.name === sName).isLoaded;
    this.setScratcherIsLoaded = (sName, value) => this.options.scratchers.find(x => x.name === sName).isLoaded = value;
    this.getScratcherCanvasTemp = (sName) => this.options.scratchers.find(x => x.name === sName).canvas.temp;
    this.setScratcherCanvasTemp = (sName, value) => this.options.scratchers.find(x => x.name === sName).canvas.temp = value;
    this.getScratcherCanvasDraw = (sName) => this.options.scratchers.find(x => x.name === sName).canvas.draw;
    this.setScratcherCanvasDraw = (sName, value) => this.options.scratchers.find(x => x.name === sName).canvas.draw = value;
    this.getScratcherImageFront = (sName) => this.options.scratchers.find(x => x.name === sName).images.front;
    this.setScratcherImageFront = (sName, value) => this.options.scratchers.find(x => x.name === sName).images.front = value;
    this.getScratcherImageBack = (sName) => this.options.scratchers.find(x => x.name === sName).images.back;
    this.setScratcherImageBack = (sName, value) => this.options.scratchers.find(x => x.name === sName).images.back = value;

    this.getIsMouseDown = () => this.options.isMouseDown;
    this.setIsMouseDown = (value) => this.options.isMouseDown = value;


    this.initializeScratcher = function ($container) {
        let scratcher;
        let $canvas = $container.find('canvas');
        let newScratcher = {
            name: $container.data('scratcher-name'),
            containerId: $container.attr('id'),
            canvasId: $canvas.attr('id'),
            cursorImageUrl: $canvas.data('cursor-image-url'),
            images: {
                front: { url: $canvas.data('front-image-url') },
                back: { url: $canvas.data('back-image-url') }
            }
        };

        this.addScratcher($.extend(true, scratcherModel, newScratcher));

        scratcher = this.getScratcherByName($container.data('scratcher-name'));

        this.loadingIndicator($container, scratcher.name);
        this.loadImages($container, scratcher.name);
        this.initializeCursorImage(scratcher.name);

    };

    /**
     * Handle displaying loading overlay while images are loading. 
     * @param {$element} $container jquery element
     * @param {string} name scratcher name
     */
    this.loadingIndicator = function ($container, name) {
        let $el = $container.find('.loading-wave');

        if (!$el.length) return;

        $el.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
            (e) => {
                let $target = $(e.target);

                ($target.hasClass('loaded'))
                    ? $target.addClass('hidden')
                    : $target.removeClass('hidden');
            }
        );

        if (this.getScratcherIsLoaded(name)) {
            $el.removeClass('hidden loaded')
            this.setScratcherIsLoaded(name, false);
        } else {
            $el.addClass('loaded');
            this.setScratcherIsLoaded(name, true);
        }
    }

    /**
     * Handle loading of needed image resources.
     * @param {$element} $container jquery element
     * @param {string} name scratcher name
     */
    this.loadImages = function ($container, name) {
        let _images = this.getScratcherByName(name).images
        let loadCount = 0;
        let loadTotal = 0;
        let imageLoaded = (e) => {
            loadCount++;

            if (loadCount >= loadTotal) {
                this.initializeScratcherCanvases(name);
                this.loadingIndicator($container, name);
            }
        }

        for (var k in _images) {
            if (_images.hasOwnProperty(k)) {
                _images[k].img = document.createElement('img');
                _images[k].img.addEventListener('load', imageLoaded, false);
                _images[k].img.src = _images[k].url;

                loadTotal++;
            }
        }
    }

    /**
     * Override default cursor style with image.
     * @param {string} name scratcher name
     */
    this.initializeCursorImage = function (name) {
        let scratcher = this.getScratcherByName(name);

        if (!scratcher.cursorImageUrl) return;

        $(`#${scratcher.canvasId}`).css({ "cursor": `url(${scratcher.cursorImageUrl}), crosshair` });
    }

    /**
     * Set up the main canvas and listeners
     * @param {string} name scratcher name
     */
    this.initializeScratcherCanvases = function (name) {
        let _cMain = document.getElementById(this.getScratcherByName(name).canvasId);
        let _cMainWidth = $(_cMain).parent().width();
        let backImg = this.getScratcherImageBack(name).img;
        let dimensions = this.calculateDimensions(backImg.width, backImg.height, _cMainWidth);

        // create the temp and draw canvases, and set their dimensions to the same as the main canvas
        this.setScratcherCanvasTemp(name, document.createElement('canvas'));
        this.setScratcherCanvasDraw(name, document.createElement('canvas'));
        this.getScratcherCanvasTemp(name).width = this.getScratcherCanvasDraw(name).width = dimensions.W;
        this.getScratcherCanvasTemp(name).height = this.getScratcherCanvasDraw(name).height = dimensions.H;

        this.draw(name);
        this.initializeEvents(_cMain, name);
        this.initializeRevealEvent(name);
    }

    /**
     * Redraws the canvases
     * @param {string} name scratcher name
     */
    this.draw = (name) => {
        let _cMain = document.getElementById(this.getScratcherByName(name).canvasId);
        let _cMainWidth = $(_cMain).parent().width();
        let backImg = this.getScratcherImageBack(name).img;
        let frontImg = this.getScratcherImageFront(name).img;
        let dimensions = this.calculateDimensions(backImg.width, backImg.height, _cMainWidth);

        let _cTemp = this.getScratcherCanvasTemp(name);
        let _cDraw = this.getScratcherCanvasDraw(name);
        let _ctxTemp = _cTemp.getContext('2d');
        let _ctxMain = _cMain.getContext('2d');

        // Step 1: resizing clears canvases before redraw
        _ctxMain.canvas.width = dimensions.W;
        _ctxMain.canvas.height = dimensions.H;
        _ctxTemp.canvas.width = dimensions.W;
        _ctxTemp.canvas.height = dimensions.H;

        // Step 2: stamp the draw on the temp (source-over)
        _ctxTemp.drawImage(_cDraw, 0, 0, _cTemp.width, _cTemp.height);

        // Step 3: stamp the background on the temp (!! source-atop mode !!)
        _ctxTemp.globalCompositeOperation = 'source-atop';
        _ctxTemp.drawImage(backImg, 0, 0, _cTemp.width, _cTemp.height);

        // Step 4: stamp the foreground on the display canvas (source-over)
        _ctxMain.drawImage(frontImg, 0, 0, _cTemp.width, _cTemp.height);

        // Step 5: stamp the temp on the display canvas (source-over)
        _ctxMain.drawImage(_cTemp, 0, 0, _cTemp.width, _cTemp.height);
    }

    /** Scratch line and redraw canvas
     *  -- strokeStyle can be any 'opaque' color
     * @param {event} e mouse event
     * @param {string} name scratcher name
     * @param {boolean} newLine begin a new line if true
     */
    this.scratch = (event, name, newLine) => {
        let _cMain = document.getElementById(this.getScratcherByName(name).canvasId);
        let pos = this.getCanvasRelativeMousePosition(event, _cMain);
        let _ctxMain = this.getScratcherCanvasDraw(name).getContext('2d');

        _ctxMain.lineWidth = 50;
        _ctxMain.lineCap = _ctxMain.lineJoin = 'round';
        _ctxMain.strokeStyle = 'rgba(255,255,255,1)';

        if (newLine) {
            _ctxMain.beginPath();
            _ctxMain.moveTo(pos.x + 0.01, pos.y);
        }
        _ctxMain.lineTo(pos.x, pos.y);
        _ctxMain.stroke();

        this.draw(name);
    }

    /**
     * Reveal the bottom image without 'scratching' manually.
     * Ex. This is called on 'reveal' click event.
     * @param {string} name scratcher name
     */
    this.reveal = (name) => {
        let _cDraw = this.getScratcherCanvasDraw(name);
        let _ctxDraw = _cDraw.getContext('2d');
        _ctxDraw.fillStyle = 'rgba(255,255,255,1)';
        _ctxDraw.fillRect(0, 0, _cDraw.width, _cDraw.height);

        this.draw(name);
    }

    /** Returns mouse position reletive to canvas object.
     * NOTE: Assumes canvas object has no padding and no border.
     * 
     * Additional Info: https://stackoverflow.com/questions/20060691/most-modern-method-of-getting-mouse-position-within-a-canvas-in-native-javascrip/35741551#35741551
     * 
     * @param {event} event mouse event
     * @param {*} target canvas element, defaults to event.target
     */
    this.getCanvasRelativeMousePosition = (event, target) => {
        target = target || event.target;
        let pos;

        (event.type === 'touchstart' || event.type === 'touchmove')
            ? pos = this.getRelativeTouchPosition(event, target)
            : pos = this.getRelativeMousePosition(event, target);

        pos.x = pos.x * target.width / target.clientWidth;
        pos.y = pos.y * target.height / target.clientHeight;

        return pos;
    }
    /** See also: getCanvasRelativeMousePosition()
     * 
     * @param {event} event mouse event
     * @param {*} target canvas element, defaults to event.target
     */
    this.getRelativeMousePosition = (event, target) => {
        target = target || event.target;
        let rect = target.getBoundingClientRect();

        return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top,
        }
    }
    this.getRelativeTouchPosition = (event, target) => {
        target = target || event.target;
        let rect = target.getBoundingClientRect();

        return {
            x: event.touches[0].clientX - rect.left,
            y: event.touches[0].clientY - rect.top
        };
    }

    this.resizeCanvas = (e, name) => {
        let _cMain = document.getElementById(this.getScratcherByName(name).canvasId);
        let _cMainWidth = $(_cMain).parent().width();
        let _cTemp = this.getScratcherCanvasTemp(name);
        let _cDraw = this.getScratcherCanvasDraw(name);
        let backImg = this.getScratcherImageBack(name).img;
        let dimensions = this.calculateDimensions(backImg.width, backImg.height, _cMainWidth);
        let _ctxDraw = _cDraw.getContext('2d');

        //Need to maintain what was drawn before
        //set current canvas draw to image
        let cDrawImg = new Image();
        cDrawImg.src = _cDraw.toDataURL();
        cDrawImg.onload = () => {
            //redraw image
            _ctxDraw.drawImage(cDrawImg, 0, 0, dimensions.W, dimensions.H);
            this.draw(name);
        }

        //resize
        _cTemp.width = _cDraw.width = dimensions.W;
        _cTemp.height = _cDraw.height = dimensions.H;
    }
    this.calculateDimensions = function (srcWidth, srcHeight, canvasWidth) {
        let aspectRatio = srcHeight / srcWidth;
        return { W: canvasWidth, H: aspectRatio * canvasWidth };
    }

    /**
     * Setup event to handle auto-reveal of scratcher
     * @param {string} name scratcher-name
     */
    this.initializeRevealEvent = function (name) {
        let containerId = this.getScratcherByName(name).containerId;
        let revealAction = $(`#${containerId}`).find('.scratcher-reveal');

        revealAction.on('click', (e) => this.reveal(name));
    }

    /**
     * Initialize mouse events
     * 
     * @param {*} c canvas element 
     * @param {string} name scratcher name
     */
    this.initializeEvents = function (c, name) {
        c.addEventListener('mousedown', (e) => this.handleMouseDown(e, name), false);
        window.addEventListener('mousemove', (e) => this.handleMouseMove(e, name), false);
        window.addEventListener('mouseup', (e) => this.handleMouseUp(e), false);

        c.addEventListener("touchstart", (e) => this.handleTouch(e, name), false);
        c.addEventListener("touchend", (e) => this.handleTouch(e, name), false);
        c.addEventListener("touchmove", (e) => this.handleTouch(e, name), false);

        document.body.addEventListener("touchstart", this.preventDefaultTouch, false);
        document.body.addEventListener("touchend", this.preventDefaultTouch, false);
        document.body.addEventListener("touchmove", this.preventDefaultTouch, false);

        window.addEventListener('resize', _debounce((e) => this.resizeCanvas(e, name), 250), false);
    }

    /**
     * On mouse down
     * 
     * -- This applies to 'canvas' so we only start drawing when mouse event originates within the canvas.
     * @param {event} e mouse event
     */
    this.handleMouseDown = (e, name) => {
        this.setIsMouseDown(true);

        this.scratch(e, name, true);

        if (e.cancelable)
            e.preventDefault();

        return false;
    };

    /**
     * On mouse move, if mouse down, draw a line
     *
     * -- This applies to 'window' to handle mousing outside the canvas itself
     * @param {event} e mouse event
     * @param {string} name scratcher name
     */
    this.handleMouseMove = (e, name) => {
        if (!this.getIsMouseDown())
            return true;

        this.scratch(e, name, false);

        if (e.cancelable)
            e.preventDefault();

        return false;
    };

    /**
     * On mouse up
     * 
     * -- This applies to 'window' to handle mouse events outside the canvas itself
     * @param {event} e mouse event
     */
    this.handleMouseUp = (e) => {
        if (this.getIsMouseDown()) {
            this.setIsMouseDown(false);

            if (e.cancelable)
                e.preventDefault();
        }

        return false;
    };

    /**
     * Handle touch events
     * @param {event} e
     */
    this.handleTouch = (e, name) => {
        if (e.targetTouches.length == 1) { //one finger touch
            if (e.type == "touchstart") {
                this.handleMouseDown(e, name);
            } else if (e.type === "touchmove") {
                this.handleMouseMove(e, name);
            } else if (e.type === "touchend" || e.type === "touchcancel") {
                this.handleMouseUp(e);
            }
        }
    }

    /**
     * Prevent default touch events if the target is the canvas.
     * This will prevent scrolling on touch devices when the touch event originates from canvas
     * @param {event} e 
     */
    this.preventDefaultTouch = (e) => {
        if (e.target == canvas)
            e.preventDefault();
    }
};

module.exports = digitalScratcherService;


// WEBPACK FOOTER //
// ./features/scratchers/digital-scratcher-service.js